export const RestrictHeaderMovementStart = 'RestrictHeaderMovementStart';
export const RestrictHeaderMovementEnd = 'RestrictHeaderMovementEnd';
